import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const LiveClassCard = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex cursor-default flex-col gap-5 rounded-[10px] border border-solid border-neutral-lightest bg-white p-3 text-xs shadow-sm transition-all duration-150 hover:shadow-md focus:shadow-md', className)}
    {...props}
  />
));
LiveClassCard.displayName = 'LiveClassCard';

const LiveClassCardHeader = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('leading-none', className)}
    {...props}
  />
));
LiveClassCardHeader.displayName = 'LiveClassCardHeader';

const LiveClassCardHeaderInner = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mb-2 flex items-start justify-between gap-3', className)}
    {...props}
  />
));
LiveClassCardHeaderInner.displayName = 'LiveClassCardHeaderInner';

const LiveClassCardTitle = React.forwardRef(({ className, variant, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('mb-0 inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap font-bold text-primary-dark', className)}
    {...props}
  />
));
LiveClassCardTitle.displayName = 'LiveClassCardTitle';

const LiveClassCardBody = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mb-0', className)}
    {...props}
  />
));
LiveClassCardBody.displayName = 'LiveClassCardBody';

const LiveClassCardTime = React.forwardRef(({ className, variant, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 flex items-center gap-1 text-xs font-light text-neutral-dark', className)}
    {...props}
  />
));
LiveClassCardTime.displayName = 'LiveClassCardTime';

const LiveClassCardFooter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mb-0', className)}
    {...props}
  />
));
LiveClassCardFooter.displayName = 'LiveClassCardFooter';

export { LiveClassCard, LiveClassCardHeader, LiveClassCardHeaderInner, LiveClassCardTitle, LiveClassCardBody, LiveClassCardTime, LiveClassCardFooter };
